import { React, useRef, useState, useEffect } from "react";

import Footer2 from "./Footer2";
import HeaderLower from "./HeaderLower";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import secureLocalStorage from "react-secure-storage";

import RegisterService from "../services/register.service";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import Select from "react-select";

// import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function RegisterForm(props) {
  const TITLE = process.env.REACT_APP_API_SITE_TITLE + " | Registration Form";
  const [fields, setFields] = useState({
    name: "",
    lname: "",
    emailid: "",
    // address: "",
    // p_address: "",
    // city: "",
    // state: "",
    comments: "",
    phone: "",
    showroom: "",
    purchase: "",
    sales: "",
  });

  const [errors, setErrors] = useState({});
  // const recaptchaRef = useRef(null);

  // const [signoutTime, setSignoutTime] = useState(900000);
  // const [states, setStates] = useState([]);
  const [storeId, setStoreId] = useState([]);
  const [hfcList, setHfcList] = useState([]);
  const [empShow, setempShow] = useState("");
  const data = [
    "Gateway Woods Adoption, Foster Care, & Family Services",
    "Rescue Mission Homeless Shelter",
    "Charis House Women & Children's Shelter",
  ];

  const result = data.map((item) => ({
    value: item,
    label: item,
  }));
  // const [captcha, setCaptcha] = useState(false);

  const navigate = useNavigate();

  secureLocalStorage.removeItem("registerform");

  useEffect(() => {
    // async function getStates() {
    //   let errors = {};

    //   try {
    //     const response = await UserformService.getStates();

    //     var states = response.data.data;
    //     const results = [];
    //     states.map((value) => {
    //       return results.push({
    //         value: value.code,
    //         label: value.state_name,
    //       });
    //     });
    //     await setStates([...results]);

    //     errors["voucher"] = response.data.response;
    //   } catch (err) {
    //     if (err.status === 429 || err.status === "429") {
    //       alert("Max Limit Reached. Please wait.");
    //     }
    //   }
    // }

    async function getStoreLocation() {
      let errors = {};

      try {
        //FIXME remove this service if not used
        const response = await RegisterService.getStoreLocation();

        var value = response.data.data;
        const results = [];
        value.map((value) => {
          return results.push({
            value: value.id,
            label: value.store_location,
          });
        });
        await setStoreId([...results]);

        if (response.data.status === 429 || response.data.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
        if (value.includes("redirect")) {
        } else {
          errors["questionnare"] = response.data.response;
        }
      } catch (err) {
        if (err.status === 429 || err.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
      }
    }

    // if (localStorage.getItem("return_page") !== "true") {
    //   window.location.href = "/register";
    // } else {
    // }
    getStoreLocation();
    // getStates();

    window.history.pushState(null, document.title, window.location.href);
    const handleBackButton = (event) => {
      event.preventDefault();
    };
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  // timeout();
  // function timeout() {
  //   setTimeout(function () {
  //     logout();
  //   }, signoutTime);
  // }

  // const logout = () => {
  //   destroy();
  // };

  // const destroy = () => {
  //   localStorage.setItem("returnpage", true);
  //   localStorage.removeItem("return_page");
  //   localStorage.removeItem("registerForm");
  //   localStorage.removeItem("isRegister");
  // };
  const [resetKey1, setResetKey1] = useState(0);

  async function getHfcByStoreId(id = "") {
    setResetKey1(resetKey1 + 1);
    if (id) {
      try {
        await setempShow("loading");
        const response = await RegisterService.getHfc(id);

        var value = response.data.data;
        const results = [];
        value.map((value) => {
          return results.push({
            value: value.id,
            label: value.name,
          });
        });
        await setHfcList([...results]);
        await setempShow("success");
      } catch (err) {
        await setHfcList([]);
      }
    } else {
      setHfcList([]);
      await setempShow("error");
    }
  }

  const ref = useRef();

  const handleChange = (e) => {
    let { value, name } = e.target;
    if (name === "store_location" && value === "true") {
      value = "";
    }

    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };
  const saveErrors = (err) => {
    setErrors(err);
  };

  const submituserRegistrationForm = (e) => {
    e.preventDefault();

    let data = {
      fname: fields?.name,
      lname: fields?.lname,
      email: fields?.emailid,

      sales_name: fields?.sales,
      phone: fields?.phone,
      store_location: fields?.showroom,
      purchase: fields?.purchase,
      comments: fields?.comments,
    };

    try {
      const responseuserform = RegisterService.regData(data);
      responseuserform
        .then((response) => {
          var valueUserform = response?.data?.status;

          Swal.fire({
            title: "Successful!",
            text: "Form Submitted!",
            type: "success",
            icon: "success",
          }).then((result) => {
            secureLocalStorage.setItem(
              "registerform",
              JSON.stringify({
                name: fields.name,
                lname: fields.lname,
                emailid: fields.emailid,
                address: fields.address,
                p_address: fields.p_address,
                city: fields.city,
                state: fields.state,
                zipcode: fields.zipcode,
                sales_name: fields.sales,
                phone: fields.phone,
                store_location: fields.showroom,
                purchase: fields?.purchase,
                comments: fields?.comments,
              })
            );
            localStorage.removeItem("return_page");
            localStorage.setItem("isRegister", true);
            navigate("/register/registration-thankyou");
          });
        })
        .catch((err) => {
          if (
            err?.response?.data?.message &&
            typeof err?.response?.data?.message === "string"
          ) {
            Swal.fire({
              title: "Error!",
              text: err?.response?.data?.message,
              type: "error",
              icon: "error",
            });
          }
          let errorData = {};
          errorData["name"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.fname &&
            err?.response?.data?.message.fname[0];

          errorData["lname"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.lname &&
            err?.response?.data?.message.lname[0];
          errorData["emailid"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.email &&
            err?.response?.data?.message.email[0];
          errorData["address"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.address &&
            err?.response?.data?.message.address[0];
          errorData["p_address"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.p_address &&
            err?.response?.data?.message.p_address[0];
          errorData["city"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.city &&
            err?.response?.data?.message.city[0];
          errorData["state"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.state &&
            err?.response?.data?.message.state[0];
          errorData["zipcode"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.zip &&
            err?.response?.data?.message.zip[0];
          errorData["sales"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.sales_name &&
            err?.response?.data?.message.sales_name[0];
          errorData["phone"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.phone &&
            err?.response?.data?.message.phone[0];
          errorData["comments"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.comments &&
            err?.response?.data?.message.comments[0];

          errorData["showroom"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.store_location &&
            err?.response?.data?.message.store_location[0];
          errorData["purchase"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.purchase &&
            err?.response?.data?.message.purchase[0];
          errorData["checkederrorcaptcha"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.captcha &&
            err?.response?.data?.message.captcha[0];

          errorData["checkederrortwo"] =
            err?.response?.data?.message &&
            err?.response?.data?.message.size &&
            err?.response?.data?.message.size[0];
          saveErrors(errorData);
          ref?.current?.focus();
        });
    } catch (err) {
      alert(err);
      if (err.response.status === 429 || err.response.status === "429") {
        alert("Max Limit Reached. Please wait.");
      }
      let errorData = {};
      errorData["name"] = err?.response?.data?.message.fname[0];
      errorData["lname"] = err?.response?.data?.message.lname[0];
      errorData["emailid"] = err?.response?.data?.message.phone[0];
      errorData["address"] = err?.response?.data?.message.address[0];
      errorData["p_address"] = err?.response?.data?.message.p_address[0];
      errorData["city"] = err?.response?.data?.message.city[0];
      errorData["state"] = err?.response?.data?.message.state[0];
      errorData["sales"] = err?.response?.data?.message.sales[0];
      errorData["zipcode"] = err?.response?.data?.message.zip[0];
      errorData["phone"] = err?.response?.data?.message.phone[0];
      errorData["showroom"] = err?.response?.data?.message.showroom[0];
      errorData["purchase"] = err?.response?.data?.message.purchase[0];
      errorData["comments"] = err?.response?.data?.message.comments[0];

      errorData["checkederrorcaptcha"] =
        err?.response?.data?.message.captcha[0];
      // errorData["sales_name"] = err?.response?.data?.message.sales_name[0];
      saveErrors(errorData);
    }
  };

  const pasted = (e) => {
    e.preventDefault();
    return false;
  };

  const onlyNumbers = (evt) => {
    const { name, value } = evt.target;
    evt.target.value = evt.target.value.replace(/[^0-9]+/g, "");

    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: evt.target.value,
      };
    });
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="container-fluid">
        {/* <HeaderInner/> */}
        <HeaderLower />
        <div id="main-registration-container">
          <div className="white-box form" id="font-style">
            <h1>Register your guest for their $20 Mastercard!</h1>
            <hr />
            <form
              name="userRegistrationForm"
              className="form-outer"
              onSubmit={submituserRegistrationForm}
              // onClick={this.popup}
            >
              <div className="row">
                <div className="col-md-6">
                  <label className="formsub">
                    Customer First Name <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Customer First Name"
                    style={errors.name ? { border: "1px solid red" } : null}
                    name="name"
                    id="fname"
                    className="searchBox_deals vc-validate"
                    ref={errors.name ? ref : null}
                    value={fields.name || ""}
                    autoFocus=""
                    onChange={handleChange}
                  />
                  <div className="errorMsg">{errors.name}</div>
                </div>
                <div className="col-md-6">
                  <label className="formsub">
                    Customer Last Name <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    name="lname"
                    style={
                      errors.lname && !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    placeholder="Customer Last Name"
                    id="lname"
                    className="searchBox_deals vc-validate"
                    value={fields.lname || ""}
                    ref={errors.lname && !errors.name ? ref : null}
                    autoFocus=""
                    onChange={handleChange}
                  />
                  <div className="errorMsg">
                    {errors.lname && !errors.name ? errors.lname : null}
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="formsub">
                    Customer Email <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    name="emailid"
                    ref={
                      errors.emailid && !errors.lname && !errors.name
                        ? ref
                        : null
                    }
                    style={
                      errors.emailid && !errors.lname && !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    id="emailid"
                    placeholder="Customer Email"
                    value={fields.emailid || ""}
                    autoFocus=""
                    onChange={handleChange}
                  />
                  <div className="errorMsg">
                    {errors.emailid && !errors.lname && !errors.name
                      ? errors.emailid
                      : null}
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="formsub">
                    Customer Phone # <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    id="phone"
                    style={
                      errors.phone &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    name="phone"
                    placeholder="Customer Phone"
                    value={fields.phone || ""}
                    ref={
                      errors.phone &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    onChange={handleChange}
                    onKeyUp={onlyNumbers}
                    onPaste={pasted}
                    maxLength={10}
                  />
                  <div className="errorMsg">
                    {" "}
                    {errors.phone &&
                    !errors.emailid &&
                    !errors.lname &&
                    !errors.name
                      ? errors.phone
                      : null}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="formsub">
                    Choose a Charity (Purchase with Purpose)
                    <span className="red_point"> *</span>
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    className={`select_1 dropdown ${
                      errors.purchase &&
                      !errors.zipcode &&
                      !errors.state &&
                      !errors.City &&
                      !errors.p_address &&
                      !errors.address &&
                      !errors.phone &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? "error-select-search"
                        : ""
                    }`}
                    placeholder="Select an Option"
                    options={result}
                    isSearchable={true}
                    isClearable={true}
                    name="purchase"
                    ref={
                      errors.purchase &&
                      !errors.zipcode &&
                      !errors.state &&
                      !errors.City &&
                      !errors.p_address &&
                      !errors.address &&
                      !errors.phone &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    onChange={(selectedOption) => {
                      setFields((prevValue) => {
                        return {
                          ...prevValue,
                          ["purchase"]: selectedOption?.value
                            ? selectedOption.value
                            : "",
                        };
                      });
                    }}
                  />

                  <div className="errorMsg">
                    {errors.purchase &&
                    !errors.zipcode &&
                    !errors.state &&
                    !errors.City &&
                    !errors.p_address &&
                    !errors.address &&
                    !errors.phone &&
                    !errors.emailid &&
                    !errors.lname &&
                    !errors.name
                      ? errors.purchase
                      : null}
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="formsub">
                    Store Location<span className="red_point"> *</span>
                  </label>

                  <Select
                    classNamePrefix="react-select"
                    className={`select_1 dropdown ${
                      errors.showroom &&
                      !errors.zipcode &&
                      !errors.purchase &&
                      !errors.state &&
                      !errors.City &&
                      !errors.p_address &&
                      !errors.address &&
                      !errors.phone &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? "error-select-search"
                        : ""
                    }`}
                    placeholder="Select Store Location"
                    options={storeId}
                    isSearchable={true}
                    isClearable={true}
                    name="showroom"
                    ref={
                      errors.showroom &&
                      !errors.purchase &&
                      !errors.zipcode &&
                      !errors.state &&
                      !errors.City &&
                      !errors.p_address &&
                      !errors.address &&
                      !errors.phone &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    onChange={(selectedOption) => {
                      setFields((prevValue) => {
                        return {
                          ...prevValue,
                          ["showroom"]: selectedOption?.value
                            ? selectedOption?.value
                            : "",
                          ["sales"]: "",
                        };
                      });
                      getHfcByStoreId(selectedOption?.value);
                    }}
                  />

                  <div className="errorMsg">
                    {errors.showroom &&
                    !errors.zipcode &&
                    !errors.state &&
                    !errors.purchase &&
                    !errors.City &&
                    !errors.p_address &&
                    !errors.address &&
                    !errors.phone &&
                    !errors.emailid &&
                    !errors.lname &&
                    !errors.name
                      ? errors.showroom
                      : null}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="formsub">
                    HFC<span className="red_point"> *</span>
                  </label>

                  {empShow === "" || empShow === "success" ? (
                    <Select
                      key={resetKey1}
                      classNamePrefix="react-select"
                      className={`select_1 dropdown ${
                        errors.sales &&
                        !errors.showroom &&
                        !errors.zipcode &&
                        !errors.purchase &&
                        !errors.state &&
                        !errors.City &&
                        !errors.p_address &&
                        !errors.address &&
                        !errors.phone &&
                        !errors.emailid &&
                        !errors.lname &&
                        !errors.name
                          ? "error-select-search"
                          : ""
                      }`}
                      placeholder="Select HFC"
                      options={hfcList}
                      isSearchable={true}
                      isClearable={true}
                      name="sales"
                      ref={
                        errors.sales &&
                        !errors.showroom &&
                        !errors.zipcode &&
                        !errors.purchase &&
                        !errors.state &&
                        !errors.City &&
                        !errors.p_address &&
                        !errors.address &&
                        !errors.phone &&
                        !errors.emailid &&
                        !errors.lname &&
                        !errors.name
                          ? ref
                          : null
                      }
                      onChange={(selectedOption) => {
                        setFields((prevValue) => {
                          return {
                            ...prevValue,
                            ["sales"]: selectedOption?.value
                              ? selectedOption?.value
                              : "",
                          };
                        });
                      }}
                    />
                  ) : empShow === "error" ? (
                    <div className="select-skelton">
                      <span>No HFC Found </span>
                    </div>
                  ) : (
                    <div className="select-skelton placeholder-glow">
                      <span className="placeholder"></span>
                    </div>
                  )}

                  {/* <input
                    type="text"
                    id="sales"
                    style={
                      errors.sales &&
                      !errors.showroom &&
                      !errors.zipcode &&
                      !errors.state &&
                      !errors.City &&
                      !errors.p_address &&
                      !errors.address &&
                      !errors.phone &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    name="sales"
                    placeholder="Sales Associate #"
                    value={fields.sales || ""}
                    ref={
                      errors.sales &&
                      !errors.showroom &&
                      !errors.zipcode &&
                      !errors.state &&
                      !errors.City &&
                      !errors.p_address &&
                      !errors.address &&
                      !errors.phone &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    onChange={handleChange}
                    onKeyUp={onlyNumbers}
                    onPaste={pasted}
                  /> */}
                  <div className="errorMsg">
                    {errors.sales &&
                    !errors.showroom &&
                    !errors.zipcode &&
                    !errors.state &&
                    !errors.City &&
                    !errors.purchase &&
                    !errors.p_address &&
                    !errors.address &&
                    !errors.phone &&
                    !errors.emailid &&
                    !errors.lname &&
                    !errors.name
                      ? errors.sales
                      : null}
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="formsub">
                    Notes <span className="red_point"></span>
                  </label>
                  <input
                    type="text"
                    id="phone"
                    style={
                      errors.comments &&
                      !errors.sales &&
                      !errors.showroom &&
                      !errors.zipcode &&
                      !errors.state &&
                      !errors.City &&
                      !errors.purchase &&
                      !errors.p_address &&
                      !errors.address &&
                      !errors.phone &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    name="comments"
                    placeholder="Notes"
                    value={fields.comments || ""}
                    ref={
                      errors.comments &&
                      !errors.sales &&
                      !errors.showroom &&
                      !errors.zipcode &&
                      !errors.state &&
                      !errors.City &&
                      !errors.purchase &&
                      !errors.p_address &&
                      !errors.address &&
                      !errors.phone &&
                      !errors.emailid &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    onChange={handleChange}
                  />
                  <div className="errorMsg">
                    {" "}
                    {errors.comments &&
                    !errors.sales &&
                    !errors.showroom &&
                    !errors.zipcode &&
                    !errors.state &&
                    !errors.City &&
                    !errors.purchase &&
                    !errors.p_address &&
                    !errors.address &&
                    !errors.phone &&
                    !errors.emailid &&
                    !errors.lname &&
                    !errors.name
                      ? errors.comments
                      : null}
                  </div>
                </div>
                <br />

                <div className="clearfix"></div>
              </div>
              {/* <div className="overflow-hider">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_API_GOOGLESITEKEY}
                  onChange={onCaptchaChange}
                  ref={recaptchaRef}
                />
              </div>
              <div className="errorMsg">
                {!errors.sales &&
                !errors.showroom &&
                !errors.zipcode &&
                !errors.state &&
                !errors.City &&
                !errors.p_address &&
                !errors.address &&
                !errors.phone &&
                !errors.emailid &&
                !errors.lname &&
                !errors.name
                  ? errors.checkederrorcaptcha
                  : null}
              </div> */}

              <div className="alert alert-info">
                Limit 1 per household, while supplies last. Some restrictions
                apply, see store for detail.
              </div>
              <input
                type="submit"
                name="submit"
                id="submit"
                value="SUBMIT"
                className="sub-btn2 button Formfirst"
              />
            </form>
          </div>
        </div>
      </div>
      <Footer2 />
    </>
  );
}
export default RegisterForm;
